import { render, staticRenderFns } from "./OsakaRirekishoPreview.vue?vue&type=template&id=6cd2a6a4&scoped=true&"
import script from "./OsakaRirekishoPreview.vue?vue&type=script&lang=js&"
export * from "./OsakaRirekishoPreview.vue?vue&type=script&lang=js&"
import style0 from "./OsakaRirekishoPreview.vue?vue&type=style&index=0&id=6cd2a6a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd2a6a4",
  null
  
)

export default component.exports